import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Input, InputGroup } from 'reactstrap';

import logIcon from '../../../../Res/Icon/logImg.png';
import LogsDetails from './LogsDetails';

class LogsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterValue: '',
      savedList: [],
      updateFlag: false,
    };
  }
  componentDidMount() {
    this.setState({ updateFlag: true });
  }
  componentDidUpdate(prevProps) {
    const { boxLogs } = this.props;
    const { updateFlag } = this.state;
    if (boxLogs && prevProps.boxLogs !== boxLogs && updateFlag) {
      this.setState({
        savedList: boxLogs,
        updateFlag: false,
      });
    }
  }
  onSearch = () => {
    const { filterValue, savedList } = this.state;
    const newData = savedList.filter(item => {
      const itemData = `${item.event.toUpperCase()}`;
      const textData = filterValue.toUpperCase();
      return itemData.indexOf(textData) > -1;
    });
    if (filterValue.length > 0) {
      this.props.filterLogs(newData);
    } else {
      this.props.filterLogs(savedList);
    }
  };
  onKeyPress = async e => {
    if (e.key === 'Enter') {
      this.onSearch();
    }
  };
  render() {
    const { isOpen, onCancel, boxDetails, boxLogs } = this.props;
    const filterInput = (
      <div className="maskField-container-filter">
        <InputGroup>
          <Input
            type="text"
            placeholder={`Filter`}
            value={this.state.filterValue}
            onKeyDown={e => this.onKeyPress(e)}
            onChange={e => this.setState({ filterValue: e.target.value })}
            style={{ marginBottom: '1em' }}
          />
          <Button color="primary" className="box-search-btn" onClick={this.onSearch}>
            Search
          </Button>
        </InputGroup>
      </div>
    );
    return (
      <Modal isOpen={isOpen} toggle={onCancel} className="create-box-modal">
        <ModalHeader close={filterInput}>
          <img className="actions-icon" src={logIcon} alt="..." /> Serial Number:{' '}
          {boxDetails.serialNumber}
        </ModalHeader>
        <ModalBody>
          <LogsDetails boxLogs={boxLogs} boxDetails={boxDetails} />
        </ModalBody>
        <ModalFooter>
          <Button outline color="secondary" onClick={onCancel}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default LogsModal;
